export default {
  on: {
    pageInit() {
      const app = this.$app;
      const $page = this.$el;
      const loggedIn = !!localStorage.getItem('authToken');
      $page.removeClass('stp--in stp--out').addClass(loggedIn ? 'stp--in' : 'stp--out');
      const profileLink = $page.find('.stp__profile');
      const nameEl = $page.find('.stp__profile-name');
      const contactEl = $page.find('.stp__profile-contact');
      const avatarEl = $page.find('.stp__profile-avatar');
      const viewEl = $page.find('.stp__profile-view');
      if (!loggedIn) {
        profileLink.removeClass('popup-open').removeAttr('data-popup');
        nameEl.text('Guest User');
        contactEl.text('Log in to your account');
        if (avatarEl.length) {
          avatarEl.attr('src', 'https://ui-avatars.com/api/?background=201a0e&color=dfc288&rounded=true&bold=true&font-size=0.42&name=Guest');
        }
        viewEl.html('Log in <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4"><polyline points="9 18 15 12 9 6"/></svg>');
        profileLink.off('click').on('click', function (e) {
          e.preventDefault();
          app.views.main.router.navigate('/login/');
        });
      } else if (app.methods && typeof app.methods.getUserData === 'function') {
        app.methods.getUserData(function (data) {
          if (!data || data.isLoggedin !== 'true')
            return;
          if (nameEl.length && data.name)
            nameEl.text(data.name);
          if (contactEl.length) {
            const dial = data.dialCode || data.dial_code || data.countryCode || '';
            contactEl.text(data.phone ? (dial ? dial + ' ' : '') + data.phone : data.email || 'Tap to view profile');
          }
          if (avatarEl.length && data.name) {
            avatarEl.attr('src', 'https://ui-avatars.com/api/?background=201a0e&color=dfc288&length=2&rounded=true&bold=true&font-size=0.42&name=' + encodeURIComponent(data.name));
          }
        });
      }
      const notifToggle = document.getElementById('stp-notif');
      if (notifToggle) {
        notifToggle.checked = localStorage.getItem('notifEnabled') !== 'false';
        notifToggle.addEventListener('change', function () {
          localStorage.setItem('notifEnabled', notifToggle.checked ? 'true' : 'false');
          app.toast.show({
            text: notifToggle.checked ? 'Notifications enabled' : 'Notifications disabled',
            closeTimeout: 1800
          });
        });
      }
      const AUTH_URL = (window.baseURL || 'https://api.digitalmoneyexpress.com/') + 'v1/ajaxAuthentication.php';
      function netErr() {
        app.dialog.close();
        app.toast.show({
          text: 'No internet connection!',
          closeTimeout: 3000
        });
      }
      function toast(t) {
        app.toast.show({
          text: t,
          closeTimeout: 2600
        });
      }
      function setText(sel, val) {
        document.querySelectorAll(sel).forEach(function (el) {
          el.textContent = val;
        });
      }
      const epName = document.getElementById('epName');
      if (epName) {
        epName.addEventListener('input', function () {
          var v = epName.value.replace(/[^A-Za-z .'\-]/g, '');
          if (v !== epName.value)
            epName.value = v;
        });
      }
      const epDob = document.getElementById('epDob');
      var epCal = null;
      if (epDob) {
        var maxDOB = new Date();
        maxDOB.setFullYear(maxDOB.getFullYear() - 5);
        epCal = app.calendar.create({
          inputEl: epDob,
          openIn: 'popup',
          dateFormat: 'dd/mm/yyyy',
          maxDate: maxDOB,
          closeOnSelect: true,
          routableModals: false,
          toolbarCloseText: 'Done',
          monthNames: [
            'January',
            'February',
            'March',
            'April',
            'May',
            'June',
            'July',
            'August',
            'September',
            'October',
            'November',
            'December'
          ],
          monthNamesShort: [
            'Jan',
            'Feb',
            'Mar',
            'Apr',
            'May',
            'Jun',
            'Jul',
            'Aug',
            'Sep',
            'Oct',
            'Nov',
            'Dec'
          ]
        });
      }
      function epParseDob(s) {
        var m = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(s || '');
        if (!m)
          return null;
        var d = new Date(+m[3], +m[2] - 1, +m[1]);
        return isNaN(d.getTime()) ? null : d;
      }
      const epAddress = document.getElementById('epAddress');
      const epLocBtn = document.getElementById('epGetLocation');
      const epLocIcon = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="3"/><path d="M12 1v4M12 19v4M1 12h4M19 12h4"/><circle cx="12" cy="12" r="9"/></svg>';
      const epLocSpin = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="ep__loc-spin"><path d="M12 2a10 10 0 0 1 10 10"/></svg>';
      if (epLocBtn && epAddress && navigator.geolocation) {
        epLocBtn.onclick = function () {
          epLocBtn.disabled = true;
          epLocBtn.innerHTML = epLocSpin;
          navigator.geolocation.getCurrentPosition(function (pos) {
            fetch('https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=' + pos.coords.latitude + '&lon=' + pos.coords.longitude, { headers: { 'Accept-Language': 'en' } }).then(function (r) {
              return r.json();
            }).then(function (data) {
              var a = data.address || {};
              var parts = [
                a.road || a.pedestrian || a.footway,
                a.suburb || a.neighbourhood || a.quarter,
                a.city || a.town || a.village || a.county,
                a.state,
                a.country,
                a.postcode
              ].filter(Boolean);
              epAddress.value = parts.join(', ') || data.display_name || '';
            }).catch(function () {
              toast('Could not fetch your location');
            }).then(function () {
              epLocBtn.disabled = false;
              epLocBtn.innerHTML = epLocIcon;
            });
          }, function () {
            epLocBtn.disabled = false;
            epLocBtn.innerHTML = epLocIcon;
            toast('Location permission denied');
          }, {
            timeout: 10000,
            enableHighAccuracy: true
          });
        };
      } else if (epLocBtn) {
        epLocBtn.style.display = 'none';
      }
      var epDialCode = '';
      function epPrefill() {
        app.methods.getUserData(function (data) {
          if (!data || data.isLoggedin !== 'true')
            return;
          var n = document.getElementById('epName');
          var d = document.getElementById('epDob');
          var a = document.getElementById('epAddress');
          if (n)
            n.value = data.name || '';
          if (d)
            d.value = data.dob || '';
          if (a)
            a.value = data.address || '';
          if (epCal) {
            var pd = epParseDob(data.dob);
            epCal.setValue(pd ? [pd] : []);
          }
          epDialCode = data.dialCode || data.dial_code || data.countryCode || data.phonecode || '';
          var phoneTxt = data.phone ? (epDialCode ? epDialCode + ' ' : '') + data.phone : '\u2014';
          setText('#edit-profile-popup .ep__contact .profile-phone', phoneTxt);
          setText('#edit-profile-popup .ep__contact .profile-email', data.email || '\u2014');
        });
      }
      function epSetTab(tab) {
        document.querySelectorAll('#edit-profile-popup .ep__tab').forEach(function (t) {
          t.classList.toggle('ep__tab--on', t.getAttribute('data-tab') === tab);
        });
        var personal = document.querySelector('#edit-profile-popup .ep__pane--personal');
        var contact = document.querySelector('#edit-profile-popup .ep__pane--contact');
        if (personal)
          personal.style.display = tab === 'personal' ? '' : 'none';
        if (contact)
          contact.style.display = tab === 'contact' ? '' : 'none';
      }
      document.querySelectorAll('#edit-profile-popup .ep__tab').forEach(function (t) {
        t.onclick = function () {
          epSetTab(t.getAttribute('data-tab'));
        };
      });
      const editProfileBtn = document.querySelector('.stp__item--edit-profile');
      if (editProfileBtn) {
        editProfileBtn.onclick = function (e) {
          e.preventDefault();
          epPrefill();
          epSetTab('personal');
          app.popup.open('#edit-profile-popup');
        };
      }
      const epSaveBtn = document.querySelector('#edit-profile-popup .epSaveBtn');
      if (epSaveBtn) {
        epSaveBtn.onclick = function (e) {
          e.preventDefault();
          var name = (document.getElementById('epName').value || '').trim();
          var dob = (document.getElementById('epDob').value || '').trim();
          var address = (document.getElementById('epAddress').value || '').trim();
          if (name.length < 2) {
            toast('Please enter your full name');
            return;
          }
          if (name.length > 50 || !/^[A-Za-z]+(?:[ .'-]+[A-Za-z]+)*\.?$/.test(name)) {
            toast('Enter your name exactly as on your government ID (letters only)');
            return;
          }
          if (!dob) {
            toast('Please select your date of birth');
            return;
          }
          if (!/^\d{2}\/\d{2}\/\d{4}$/.test(dob)) {
            toast('Date of birth must be DD/MM/YYYY');
            return;
          }
          if (address.length < 6) {
            toast('Please enter your full address');
            return;
          }
          app.methods.request(AUTH_URL, {
            updateProfile: true,
            token: localStorage.getItem('authToken'),
            name: name,
            dob: dob,
            address: address
          }, 'json', function () {
            app.dialog.progress('Saving\u2026');
            epSaveBtn.classList.add('disabled');
          }, function (res) {
            app.dialog.close();
            epSaveBtn.classList.remove('disabled');
            if (res && res.status === 'success') {
              app.popup.close('#edit-profile-popup');
              toast(res.msg || 'Profile updated successfully');
              setText('.profile-name', name);
              setText('.profile-address', address || '\u2014');
              setText('.profile-dob', dob || '\u2014');
              document.querySelectorAll('.loggeninProfileUI').forEach(function (el) {
                el.setAttribute('src', 'https://ui-avatars.com/api/?background=201a0e&color=dfc288&length=2&rounded=true&bold=true&font-size=0.42&name=' + encodeURIComponent(name));
              });
            } else {
              toast(res && res.msg || 'Could not update profile');
            }
          }, netErr);
        };
      }
      var ccField = 'mobile';
      var ccNewVal = '';
      function ccGoStep(n) {
        [
          '1',
          '2',
          '3'
        ].forEach(function (s) {
          var pane = document.querySelector('#change-contact-popup .cc__pane--' + s);
          if (pane)
            pane.style.display = s === String(n) ? '' : 'none';
        });
        document.querySelectorAll('#change-contact-popup .cc__step-dot').forEach(function (dot) {
          var s = parseInt(dot.getAttribute('data-step'), 10);
          dot.classList.remove('cc__step-dot--on', 'cc__step-dot--done');
          if (s < n)
            dot.classList.add('cc__step-dot--done');
          else if (s === n)
            dot.classList.add('cc__step-dot--on');
        });
      }
      function ccOpen(field) {
        ccField = field;
        ccNewVal = '';
        var isMobile = field === 'mobile';
        var pop = document.getElementById('change-contact-popup');
        pop.querySelector('.cc__title').textContent = isMobile ? 'Change Mobile Number' : 'Change Email Address';
        pop.querySelectorAll('.cc__field-label').forEach(function (el) {
          el.textContent = isMobile ? 'mobile number' : 'email address';
        });
        var nl = pop.querySelector('.cc__new-label');
        if (nl)
          nl.textContent = isMobile ? 'New Mobile Number' : 'New Email Address';
        var nv = document.getElementById('ccNewValue');
        nv.value = '';
        nv.type = isMobile ? 'tel' : 'email';
        nv.setAttribute('inputmode', isMobile ? 'numeric' : 'email');
        nv.placeholder = isMobile ? 'Mobile number' : 'Enter new email address';
        var dialEl = pop.querySelector('.cc__dial');
        var newRow = pop.querySelector('.cc__new-row');
        if (isMobile && epDialCode) {
          dialEl.textContent = epDialCode;
          dialEl.style.display = '';
          if (newRow)
            newRow.classList.add('cc__has-dial');
        } else {
          dialEl.style.display = 'none';
          if (newRow)
            newRow.classList.remove('cc__has-dial');
        }
        document.getElementById('ccOldOtp').value = '';
        document.getElementById('ccNewOtp').value = '';
        pop.querySelector('.ccOldDest').textContent = '';
        pop.querySelector('.ccNewDest').textContent = '';
        ccGoStep(1);
        app.popup.open('#change-contact-popup');
      }
      document.querySelectorAll('#edit-profile-popup .ep__contact-change').forEach(function (btn) {
        btn.onclick = function () {
          app.popup.close('#edit-profile-popup');
          setTimeout(function () {
            ccOpen(btn.getAttribute('data-field'));
          }, 250);
        };
      });
      function ccRequestOld(isResend) {
        app.methods.request(AUTH_URL, {
          contactChangeRequest: true,
          token: localStorage.getItem('authToken'),
          field: ccField,
          newValue: ccNewVal
        }, 'json', function () {
          app.dialog.progress(isResend ? 'Resending\u2026' : 'Sending code\u2026');
        }, function (res) {
          app.dialog.close();
          if (res && res.status === 'success') {
            var d = document.querySelector('#change-contact-popup .ccOldDest');
            if (d)
              d.textContent = res.oldDestination ? '(' + res.oldDestination + ')' : '';
            window.otpCooldown(ccResendOld, 30);
            if (isResend) {
              toast('A new code was sent to your current contact');
            } else {
              ccGoStep(2);
            }
          } else {
            toast(res && res.msg || 'Could not send the code');
          }
        }, netErr);
      }
      const ccStep1Btn = document.querySelector('#change-contact-popup .ccStep1Btn');
      if (ccStep1Btn) {
        ccStep1Btn.onclick = function (e) {
          e.preventDefault();
          var val = (document.getElementById('ccNewValue').value || '').trim();
          if (ccField === 'mobile') {
            var digits = val.replace(/\D/g, '');
            if (digits.length < 7 || digits.length > 14) {
              toast('Enter a valid mobile number');
              return;
            }
            ccNewVal = (epDialCode ? epDialCode + ' ' : '') + digits;
          } else {
            if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(val)) {
              toast('Enter a valid email address');
              return;
            }
            ccNewVal = val;
          }
          ccRequestOld(false);
        };
      }
      const ccStep2Btn = document.querySelector('#change-contact-popup .ccStep2Btn');
      if (ccStep2Btn) {
        ccStep2Btn.onclick = function (e) {
          e.preventDefault();
          var otp = (document.getElementById('ccOldOtp').value || '').trim();
          if (!/^[0-9]{6}$/.test(otp)) {
            toast('Enter the 6-digit code');
            return;
          }
          app.methods.request(AUTH_URL, {
            contactChangeVerifyOld: true,
            token: localStorage.getItem('authToken'),
            field: ccField,
            otp: otp
          }, 'json', function () {
            app.dialog.progress('Verifying\u2026');
            ccStep2Btn.classList.add('disabled');
          }, function (res) {
            app.dialog.close();
            ccStep2Btn.classList.remove('disabled');
            if (res && res.status === 'success') {
              var d = document.querySelector('#change-contact-popup .ccNewDest');
              if (d)
                d.textContent = res.newDestination ? '(' + res.newDestination + ')' : '';
              ccGoStep(3);
              window.otpCooldown(ccResendNew, 30);
            } else {
              toast(res && res.msg || 'Incorrect or expired code');
            }
          }, netErr);
        };
      }
      const ccResendOld = document.querySelector('#change-contact-popup .ccResendOld');
      if (ccResendOld)
        ccResendOld.onclick = function (e) {
          e.preventDefault();
          if (ccResendOld.classList.contains('otp__resend--off'))
            return;
          ccRequestOld(true);
        };
      const ccStep3Btn = document.querySelector('#change-contact-popup .ccStep3Btn');
      if (ccStep3Btn) {
        ccStep3Btn.onclick = function (e) {
          e.preventDefault();
          var otp = (document.getElementById('ccNewOtp').value || '').trim();
          if (!/^[0-9]{6}$/.test(otp)) {
            toast('Enter the 6-digit code');
            return;
          }
          app.methods.request(AUTH_URL, {
            contactChangeVerifyNew: true,
            token: localStorage.getItem('authToken'),
            field: ccField,
            otp: otp
          }, 'json', function () {
            app.dialog.progress('Confirming\u2026');
            ccStep3Btn.classList.add('disabled');
          }, function (res) {
            app.dialog.close();
            ccStep3Btn.classList.remove('disabled');
            if (res && res.status === 'success') {
              app.popup.close('#change-contact-popup');
              toast(res.msg || (ccField === 'mobile' ? 'Mobile number' : 'Email address') + ' updated');
              if (ccField === 'mobile')
                setText('.profile-phone', ccNewVal);
              else
                setText('.profile-email', ccNewVal);
            } else {
              toast(res && res.msg || 'Incorrect or expired code');
            }
          }, netErr);
        };
      }
      const ccResendNew = document.querySelector('#change-contact-popup .ccResendNew');
      if (ccResendNew) {
        ccResendNew.onclick = function (e) {
          e.preventDefault();
          if (ccResendNew.classList.contains('otp__resend--off'))
            return;
          app.methods.request(AUTH_URL, {
            contactChangeResendNew: true,
            token: localStorage.getItem('authToken'),
            field: ccField
          }, 'json', function () {
            app.dialog.progress('Resending\u2026');
          }, function (res) {
            app.dialog.close();
            if (res && res.status === 'success') {
              window.otpCooldown(ccResendNew, 30);
            }
            toast(res && res.msg || 'A new code was sent to your new contact');
          }, netErr);
        };
      }
      const clearBtn = document.querySelector('.stp__item--clear-cache');
      const cacheLabel = document.querySelector('.stp__cache-size');
      if ('caches' in window && cacheLabel) {
        caches.keys().then(function (keys) {
          if (!keys.length) {
            cacheLabel.textContent = 'No cache stored';
            return;
          }
          var total = 0;
          var checks = keys.map(function (k) {
            return caches.open(k).then(function (c) {
              return c.keys().then(function (reqs) {
                total += reqs.length;
              });
            });
          });
          Promise.all(checks).then(function () {
            cacheLabel.textContent = total + ' cached item' + (total === 1 ? '' : 's');
          });
        });
      } else if (cacheLabel) {
        cacheLabel.textContent = 'Tap to clear';
      }
      if (clearBtn) {
        clearBtn.addEventListener('click', function (e) {
          e.preventDefault();
          if (!('caches' in window)) {
            app.toast.show({
              text: 'Nothing to clear',
              closeTimeout: 1800
            });
            return;
          }
          caches.keys().then(function (keys) {
            Promise.all(keys.map(function (k) {
              return caches.delete(k);
            })).then(function () {
              if (cacheLabel)
                cacheLabel.textContent = 'Cache cleared';
              app.toast.show({
                text: 'App cache cleared!',
                closeTimeout: 2000
              });
            });
          });
        });
      }
    }
  },
  id: 'c5366cb950',
  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }
      function isFunction(func) {
        return typeof func === 'function';
      }
      function c(val, ctx) {
        if (typeof val !== 'undefined' && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else
            return val;
        } else
          return '';
      }
      root = root || ctx_1 || {};
      var r = '';
      r += '\n  <div class="page stp" data-name="settings">\n\n    <div class="navbar stp__navbar no-shadow">\n      <div class="navbar-bg"></div>\n      <div class="navbar-inner">\n        <div class="left">\n          <a href="#" class="link back stp__back" aria-label="Back">\n            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="15 18 9 12 15 6"/></svg>\n          </a>\n        </div>\n        <div class="title stp__title">Settings</div>\n        <div class="right"></div>\n      </div>\n    </div>\n\n    <div class="page-content stp__content" style="margin-top: 60px;">\n\n      <!-- \u2500\u2500 Profile header \u2500\u2500 -->\n      <a href="#" class="stp__profile popup-open" data-popup="#profile-popup">\n        <span class="stp__profile-halo"></span>\n        <span class="stp__profile-avatar-wrap">\n          <img class="stp__profile-avatar loggeninProfileUI"\n            src="https://ui-avatars.com/api/?background=201a0e&color=dfc288&length=2&rounded=true&bold=true&font-size=0.42&name=Guest" alt=""/>\n        </span>\n        <div class="stp__profile-info">\n          <span class="stp__profile-name profile-name">Guest User</span>\n          <span class="stp__profile-contact profile-phone">Tap to view profile</span>\n        </div>\n        <span class="stp__profile-view">\n          View\n          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4"><polyline points="9 18 15 12 9 6"/></svg>\n        </span>\n      </a>\n\n      <!-- \u2500\u2500 Guest: Login CTA (shown only when logged out) \u2500\u2500 -->\n      <div class="stp__section-label stp__guest-only">Account</div>\n      <div class="stp__group stp__guest-only">\n        <a href="/login/" data-view=".view-main" class="stp__item stp__item--login">\n          <span class="stp__ico stp__ico--gold">\n            <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"/><polyline points="10 17 15 12 10 7"/><line x1="15" y1="12" x2="3" y2="12"/></svg>\n          </span>\n          <div class="stp__item-body">\n            <span class="stp__item-title">Log In / Register</span>\n            <span class="stp__item-sub">Access your account &amp; investments</span>\n          </div>\n          <svg class="stp__chev" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><polyline points="9 18 15 12 9 6"/></svg>\n        </a>\n      </div>\n\n      <!-- \u2500\u2500 Account (shown only when logged in) \u2500\u2500 -->\n      <div class="stp__section-label stp__auth-only">Account</div>\n      <div class="stp__group stp__auth-only">\n        <a href="/kyc/" data-view=".view-main" class="stp__item">\n          <span class="stp__ico stp__ico--blue">\n            <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><path d="M9 12l2 2 4-4"/></svg>\n          </span>\n          <div class="stp__item-body">\n            <span class="stp__item-title">Identity Verification</span>\n            <span class="stp__item-sub">KYC status and documents</span>\n          </div>\n          <svg class="stp__chev" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><polyline points="9 18 15 12 9 6"/></svg>\n        </a>\n        <a href="#" class="stp__item stp__item--edit-profile">\n          <span class="stp__ico stp__ico--gold">\n            <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.12 2.12 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>\n          </span>\n          <div class="stp__item-body">\n            <span class="stp__item-title">Update Profile</span>\n            <span class="stp__item-sub">Edit your personal &amp; contact details</span>\n          </div>\n          <svg class="stp__chev" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><polyline points="9 18 15 12 9 6"/></svg>\n        </a>\n      </div>\n\n      <!-- \u2500\u2500 Security \u2500\u2500 -->\n      <!-- <div class="stp__section-label">Security</div>\n      <div class="stp__group">\n        <a href="/pin/" data-view=".view-main" class="stp__item">\n          <span class="stp__ico stp__ico--green">\n            <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="4" width="18" height="16" rx="2.5"/><line x1="7.5" y1="9" x2="7.5" y2="9.01"/><line x1="12" y1="9" x2="12" y2="9.01"/><line x1="16.5" y1="9" x2="16.5" y2="9.01"/><line x1="7.5" y1="13" x2="7.5" y2="13.01"/><line x1="12" y1="13" x2="12" y2="13.01"/><line x1="16.5" y1="13" x2="16.5" y2="13.01"/><line x1="9" y1="16.5" x2="15" y2="16.5"/></svg>\n          </span>\n          <div class="stp__item-body">\n            <span class="stp__item-title">Transaction PIN</span>\n            <span class="stp__item-sub">Manage your secure PIN cards</span>\n          </div>\n          <svg class="stp__chev" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><polyline points="9 18 15 12 9 6"/></svg>\n        </a>\n      </div> -->\n\n      <!-- \u2500\u2500 Preferences \u2500\u2500 -->\n      <div class="stp__section-label">Preferences</div>\n      <div class="stp__group">\n        <div class="stp__item stp__item--notoggle">\n          <span class="stp__ico stp__ico--purple">\n            <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 0 1-3.46 0"/></svg>\n          </span>\n          <div class="stp__item-body">\n            <span class="stp__item-title">Push Notifications</span>\n            <span class="stp__item-sub">Daily ROI credits and alerts</span>\n          </div>\n          <label class="stp__toggle" for="stp-notif">\n            <input type="checkbox" id="stp-notif" />\n            <span class="stp__toggle-track"><span class="stp__toggle-thumb"></span></span>\n          </label>\n        </div>\n        <a href="#" class="stp__item stp__item--clear-cache">\n          <span class="stp__ico stp__ico--orange">\n            <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="1 4 1 10 7 10"/><path d="M3.51 15a9 9 0 1 0 .49-3.74"/></svg>\n          </span>\n          <div class="stp__item-body">\n            <span class="stp__item-title">Clear App Cache</span>\n            <span class="stp__item-sub stp__cache-size">Calculating\u2026</span>\n          </div>\n          <svg class="stp__chev" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><polyline points="9 18 15 12 9 6"/></svg>\n        </a>\n      </div>\n\n      <!-- \u2500\u2500 Support & Legal \u2500\u2500 -->\n      <div class="stp__section-label">Support &amp; Legal</div>\n      <div class="stp__group">\n        <a href="#" class="stp__item popup-open" data-popup="#help-popup">\n          <span class="stp__ico stp__ico--teal">\n            <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 18v-6a9 9 0 0 1 18 0v6"/><path d="M21 19a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3z"/><path d="M3 19a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2H3z"/></svg>\n          </span>\n          <div class="stp__item-body">\n            <span class="stp__item-title">Help &amp; Support</span>\n            <span class="stp__item-sub">Call, WhatsApp or email us</span>\n          </div>\n          <svg class="stp__chev" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><polyline points="9 18 15 12 9 6"/></svg>\n        </a>\n        <a href="#" class="stp__item popup-open" data-popup="#about-popup">\n          <span class="stp__ico stp__ico--slate">\n            <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>\n          </span>\n          <div class="stp__item-body">\n            <span class="stp__item-title">About Us</span>\n            <span class="stp__item-sub">Learn more about DigiMExpress</span>\n          </div>\n          <svg class="stp__chev" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><polyline points="9 18 15 12 9 6"/></svg>\n        </a>\n        <a href="https://digitalmoneyexpress.com/terms-of-service/" class="stp__item external" target="_system">\n          <span class="stp__ico stp__ico--slate">\n            <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/><polyline points="10 9 9 9 8 9"/></svg>\n          </span>\n          <div class="stp__item-body">\n            <span class="stp__item-title">Terms of Service</span>\n          </div>\n          <svg class="stp__chev" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><polyline points="9 18 15 12 9 6"/></svg>\n        </a>\n        <a href="https://digitalmoneyexpress.com/privacy-policy/" class="stp__item external" target="_system">\n          <span class="stp__ico stp__ico--slate">\n            <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>\n          </span>\n          <div class="stp__item-body">\n            <span class="stp__item-title">Privacy Policy</span>\n          </div>\n          <svg class="stp__chev" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><polyline points="9 18 15 12 9 6"/></svg>\n        </a>\n      </div>\n\n      <!-- \u2500\u2500 Danger (shown only when logged in) \u2500\u2500 -->\n      <div class="stp__group stp__group--danger stp__auth-only">\n        <a href="#" class="stp__item stp__item--logout logout">\n          <span class="stp__ico stp__ico--red">\n            <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/></svg>\n          </span>\n          <div class="stp__item-body">\n            <span class="stp__item-title stp__item-title--red">Logout</span>\n          </div>\n        </a>\n      </div>\n\n      <!-- \u2500\u2500 Version footer \u2500\u2500 -->\n      <div class="stp__footer">\n        <span class="stp__footer-ver">v<span class="app-version"></span></span>\n      </div>\n\n    </div>\n  </div>\n';
      return r;
    }(this);
  },
  style: `
.stp, .stp .page-content { background: #0A0A0B !important; }

/* Logged-in / logged-out visibility (toggled in pageInit) */
.stp__auth-only, .stp__guest-only { display: none; }
.stp--in .stp__auth-only { display: block; }
.stp--out .stp__guest-only { display: block; }

.stp__navbar { background: #0A0A0B !important; border-bottom: 1px solid rgba(201,169,105,0.10) !important; }
.stp__navbar .navbar-bg { background: #0A0A0B !important; }
.stp__back { color: #C9A969 !important; }
.stp__title { color: #ffffff !important; font-weight: 700 !important; }

.stp__content {
  padding: 10px 16px calc(28px + env(safe-area-inset-bottom));
  background:
    radial-gradient(120% 40% at 50% 0%, rgba(201,169,105,0.08) 0%, transparent 55%),
    #0A0A0B !important;
}

/* Profile header */
.stp__profile {
  position: relative; overflow: hidden;
  display: flex; align-items: center; gap: 14px;
  padding: 16px 16px;
  border-radius: 18px;
  background: linear-gradient(150deg, rgba(201,169,105,0.16), rgba(201,169,105,0.04));
  border: 1px solid rgba(201,169,105,0.28);
  text-decoration: none;
  margin-bottom: 18px;
}
.stp__profile:active { background: linear-gradient(150deg, rgba(201,169,105,0.22), rgba(201,169,105,0.06)); }
.stp__profile-halo {
  position: absolute; top: -55px; right: -30px; width: 150px; height: 150px;
  border-radius: 50%; pointer-events: none;
  background: radial-gradient(circle, rgba(201,169,105,0.22), transparent 65%);
}
.stp__profile-avatar-wrap {
  position: relative; z-index: 1; flex-shrink: 0;
  width: 54px; height: 54px; border-radius: 50%;
  padding: 2px; background: linear-gradient(145deg, #dfc288, #9c7d3f);
  box-shadow: 0 6px 16px -8px rgba(201,169,105,0.8);
}
.stp__profile-avatar { width: 100%; height: 100%; border-radius: 50%; display: block; background: #201a0e; }
.stp__profile-info { position: relative; z-index: 1; flex: 1; min-width: 0; display: flex; flex-direction: column; gap: 3px; }
.stp__profile-name {
  font-size: 17px; font-weight: 800; color: #fff; letter-spacing: -0.01em;
  white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
}
.stp__profile-contact {
  font-size: 12px; color: rgba(255,255,255,0.55);
  white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
}
.stp__profile-view {
  position: relative; z-index: 1; flex-shrink: 0;
  display: inline-flex; align-items: center; gap: 2px;
  font-size: 11.5px; font-weight: 700; color: #dfc288;
  padding: 6px 8px 6px 11px; border-radius: 20px;
  background: rgba(201,169,105,0.12); border: 1px solid rgba(201,169,105,0.25);
}

/* Section labels */
.stp__section-label {
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 1.4px;
  text-transform: uppercase;
  color: rgba(201,169,105,0.55);
  padding: 6px 4px 7px;
}
.stp__group {
  border-radius: 16px; overflow: hidden;
  background: linear-gradient(160deg, #161513 0%, #111110 100%);
  border: 1px solid rgba(201,169,105,0.12);
  margin-bottom: 6px;
}
.stp__group--danger { margin-top: 10px; border-color: rgba(248,113,113,0.18); }

/* Items */
.stp__item {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 14px 14px 14px 12px;
  text-decoration: none;
  border-bottom: 1px solid rgba(255,255,255,0.05);
  transition: background 0.14s;
  cursor: pointer;
}
.stp__item:last-child { border-bottom: none; }
.stp__item:active { background: rgba(255,255,255,0.04); }

/* Icon circles */
.stp__ico {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: #fff;
}
.stp__ico--blue   { background: rgba(96,165,250,0.18); color: #60a5fa; }
.stp__ico--gold   { background: rgba(201,169,105,0.18); color: #C9A969; }
.stp__ico--green  { background: rgba(74,222,128,0.15); color: #4ade80; }
.stp__ico--purple { background: rgba(167,139,250,0.18); color: #a78bfa; }
.stp__ico--orange { background: rgba(251,146,60,0.18); color: #fb923c; }
.stp__ico--teal   { background: rgba(45,212,191,0.15); color: #2dd4bf; }
.stp__ico--slate  { background: rgba(148,163,184,0.12); color: #94a3b8; }
.stp__ico--red    { background: rgba(248,113,113,0.15); color: #f87171; }

/* Item body */
.stp__item-body { flex: 1; min-width: 0; display: flex; flex-direction: column; gap: 2px; }
.stp__item-title { font-size: 14px; font-weight: 600; color: rgba(255,255,255,0.90); }
.stp__item-title--red { color: #f87171; }
.stp__item-sub { font-size: 11.5px; color: rgba(255,255,255,0.38); }
.stp__chev { color: rgba(255,255,255,0.22); flex-shrink: 0; }

/* Toggle switch */
.stp__toggle { position: relative; display: inline-flex; cursor: pointer; flex-shrink: 0; }
.stp__toggle input { position: absolute; opacity: 0; width: 0; height: 0; }
.stp__toggle-track {
  width: 46px; height: 26px;
  background: rgba(255,255,255,0.12);
  border-radius: 13px;
  transition: background 0.2s;
  position: relative;
  border: 1px solid rgba(255,255,255,0.08);
}
.stp__toggle input:checked + .stp__toggle-track { background: rgba(201,169,105,0.85); border-color: transparent; }
.stp__toggle-thumb {
  position: absolute;
  top: 2px; left: 2px;
  width: 20px; height: 20px;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0,0,0,0.35);
  transition: transform 0.2s;
}
.stp__toggle input:checked + .stp__toggle-track .stp__toggle-thumb { transform: translateX(20px); }

/* Footer */
.stp__footer { text-align: center; padding: 10px 0 45px; }
.stp__footer-ver { font-size: 10px; color: rgba(201,169,105,0.35); font-weight: 600; }
`,
  styleScoped: false
};